import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  id: "app-sidebar-1",
  class: "bg-surface-0 h-screen h-[100dvh] hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-[1000] border-r border-surface-200 select-none w-[280px]"
};
const _hoisted_2 = {
  class: "flex flex-col h-full"
};
const _hoisted_3 = {
  class: "flex items-center gap-4 p-3 pb-2 h-[4rem]"
};
const _hoisted_4 = {
  class: "w-9 h-9 flex items-center justify-center border border-surface-200 rounded-lg p-1"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "flex flex-col gap-0.25 text-sm"
};
const _hoisted_7 = {
  class: "text-xs"
};
const _hoisted_8 = {
  class: "pb-2 px-2"
};
const _hoisted_9 = {
  class: "overflow-y-auto overflow-x-hidden flex-1 p-2 flex flex-col"
};
const _hoisted_10 = {
  class: "list-none m-0 flex flex-col gap-1"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "flex items-center gap-3 w-full"
};
const _hoisted_13 = {
  class: "flex items-center justify-between gap-1 w-full"
};
const _hoisted_14 = {
  key: 0,
  class: "ml-auto inline-block bg-surface-400 rounded-xl font-semibold leading-none text-xs py-0.5 text-surface-0 dark:text-surface-900 h-fit w-fit px-2"
};
const _hoisted_15 = {
  key: 0,
  class: "ml-auto inline-block bg-primary rounded-xl font-semibold px-2 leading-none text-xs py-0.5 text-surface-0 h-fit w-fit"
};
const _hoisted_16 = {
  key: 1,
  class: "ml-auto inline-block bg-surface-400 rounded-xl font-semibold leading-none text-xs py-0.5 text-surface-0 dark:text-surface-900 h-fit w-fit px-2"
};
const _hoisted_17 = {
  class: "mt-auto relative inline-block z-[200]"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "font-medium text-sm leading-tight"
};
const _hoisted_20 = {
  class: "list-none m-0"
};
const _hoisted_21 = {
  class: "flex flex-col items-center w-full justify-center py-1 px-2"
};
const _hoisted_22 = {
  class: "border-t border-surface-200 py-1 px-2 w-full"
};
const _hoisted_23 = {
  class: "font-medium text-sm leading-tight"
};
const _hoisted_24 = {
  class: "font-medium text-sm leading-tight"
};
const _hoisted_25 = {
  class: "border-t border-surface-200 py-1 px-2"
};
const _hoisted_26 = {
  class: "font-medium text-sm leading-tight text-red-500 dark:text-red-700"
};
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { $tf } from "@/plugins/i18n";
import { PRIVILEGES } from "@/utils/const";
import network from "@/utils/network";
import Popover from "primevue/popover";
import LanguageSelector from "@/components/common/LanguageSelector.vue";
import ThemeSelector from "@/components/common/ThemeSelector.vue";
import CommandKSearch from "@/components/search/CommandKSearch.vue";
export default {
  __name: 'SideMenu',
  setup(__props) {
    const axios = network.createAxiosInstance();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const profileMenu = ref();
    const openedMenus = ref([]);
    const pendingRequests = ref(null);
    const overtimeRequests = ref(null);

    // Store getters
    const displayName = computed(() => store.getters["session/displayName"]);
    const avatar = computed(() => store.getters["session/avatar"]);
    const env = computed(() => store.getters["env/getField"]);
    const tenantBadge = computed(() => env.value("TENANT_BADGE"));
    const pendingRequestsCount = computed(() => (pendingRequests.value?.totalPendingCount || 0) + (overtimeRequests.value?.totalPendingCount || 0));
    const logo = computed(() => process.env.VUE_APP_MENU_LOGO_CLOSED);

    // Authority helpers
    const hasAnyAuthority = (...privileges) => store.getters["session/hasAnyAuthority"](...privileges);

    // Menu items
    const menuItems = computed(() => [{
      icon: "fa-regular fa-gauge-high",
      label: $tf("sidebar.dashboard|Dashboard"),
      classList: [],
      visible: true,
      key: "dashboard",
      comingSoon: true,
      items: []
    }, {
      icon: "fa-regular fa-calendar",
      label: $tf("sidebar.time|Időkezelés"),
      classList: [],
      visible: true,
      key: "time",
      items: [{
        link: "/",
        icon: "",
        label: $tf("sidebar.time.overview|Áttekintés"),
        visible: true,
        key: "time.overview"
      }, {
        link: "/time-management/logging",
        icon: "",
        label: $tf("sidebar.time.timeLogging|Időkövetés"),
        visible: true,
        key: "time.timeLogging"
      }, {
        link: "/my-requests",
        icon: "",
        label: $tf("sidebar.time.myRequests|My requests"),
        visible: true,
        key: "time.myRequests"
      }, {
        link: "/requests",
        icon: "",
        label: $tf("sidebar.time.requests|Requests"),
        visible: true,
        key: "time.requests"
      }]
    }, {
      icon: "fa-regular fa-users",
      label: $tf("sidebar.resource|Erőforrások"),
      classList: [],
      visible: true,
      key: "resource",
      items: [{
        link: "/ralloc/utilization",
        icon: "",
        label: $tf("sidebar.resource.resourcePlanner|Erőforrás-tervezés"),
        visible: true,
        key: "resource.resourcePlanner"
      }, {
        link: "/employee-explorer",
        icon: "",
        label: $tf("sidebar.resource.employeeExplorer|Felhasználó-böngésző"),
        visible: true,
        key: "resource.employeeExplorer"
      }, {
        link: "/teams",
        icon: "",
        label: $tf("sidebar.resource.teams|Csapatok"),
        visible: true,
        key: "resource.teams"
      }]
    }, {
      icon: "fa-regular fa-briefcase",
      label: $tf("sidebar.projects.menu|Projektek"),
      classList: [],
      visible: true,
      key: "projects",
      items: [{
        link: "/projects/list#all",
        icon: "",
        label: $tf("sidebar.projects.all|Összevont"),
        visible: true,
        key: "projects.all"
      }, {
        link: "/projects/worklog",
        icon: "",
        label: $tf("sidebar.projects.worklog|Munkaütemezés"),
        visible: true,
        key: "projects.worklog"
      }, {
        link: "/projects/task",
        icon: "",
        label: $tf("sidebar.projects.task|Feladatok"),
        visible: true,
        key: "projects.task"
      }, {
        link: "/projects/clients",
        icon: "",
        label: $tf("sidebar.projects.clients|Ügyfelek"),
        visible: true,
        key: "projects.clients"
      }, {
        link: "",
        icon: "",
        label: $tf("sidebar.projects.externalCosts|Külső költségek"),
        visible: true,
        comingSoon: true,
        key: "projects.externalCosts"
      }, {
        link: "",
        icon: "",
        label: $tf("sidebar.projects.invoices|Számlák"),
        visible: true,
        comingSoon: true,
        key: "projects.invoices"
      }]
    }, {
      icon: "fa-regular fa-book",
      label: $tf("sidebar.reporting.menu|Riportok"),
      classList: [],
      visible: true,
      key: "reporting",
      comingSoon: true,
      items: []
    }]);

    // Active menu key detection
    const openMenuKeys = computed(() => {
      const currentPath = route.path;
      const currentFullPath = route.fullPath;
      const currentSidebarKey = route.meta?.sidebarItemKey;
      const keys = new Set();
      const findActiveBranch = (items, parents = []) => {
        for (const item of items) {
          if (!item.link) {
            if (item.items?.length) {
              const childMatch = findActiveBranch(item.items, [...parents, item.key]);
              if (childMatch) return true;
            }
            continue;
          }
          const linkParts = item.link.split("#");
          const linkPath = linkParts[0];
          const linkHash = linkParts[1] ? "#" + linkParts[1] : null;
          let pathMatches = false;
          if (linkHash) {
            const currentHash = currentFullPath.includes("#") ? "#" + currentFullPath.split("#")[1] : null;
            pathMatches = currentPath === linkPath && currentHash === linkHash;
          } else {
            pathMatches = currentPath === item.link || currentPath.startsWith(item.link + "/");
          }
          const keyMatches = currentSidebarKey && item.key === currentSidebarKey;
          if (pathMatches || keyMatches) {
            parents.forEach(key => keys.add(key));
            if (item.key) keys.add(item.key);
            return true;
          }
          if (item.items?.length) {
            const childMatch = findActiveBranch(item.items, [...parents, item.key]);
            if (childMatch) return true;
          }
        }
        return false;
      };
      findActiveBranch(menuItems.value);
      return keys;
    });

    // Methods
    function toggleProfileMenu(event) {
      profileMenu.value.toggle(event);
    }
    function toggleMenu(menu) {
      const idx = openedMenus.value.indexOf(menu);
      if (idx !== -1) {
        openedMenus.value.splice(idx, 1);
      } else {
        openedMenus.value.push(menu);
      }
    }
    async function logout() {
      await store.dispatch("session/logMeOut");
      router.push("/login");
    }

    // Lifecycle
    onMounted(async () => {
      openedMenus.value = ["dashboard", "time", "resource", "projects", "reporting"];
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        custom: "",
        to: "/"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: logo.value,
          alt: "logo",
          class: "cursor-pointer"
        }, null, 8, _hoisted_5)])]),
        _: 1
      }), _createElementVNode("div", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "font-bold"
      }, "Forecastify", -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(tenantBadge.value), 1)])]), _createElementVNode("div", _hoisted_8, [_createVNode(CommandKSearch)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, menuItem => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: menuItem.key
        }, [menuItem.link && menuItem.visible ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: menuItem.link,
          class: "flex items-center cursor-pointer p-2 gap-4 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150"
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass(`${menuItem.icon} !text-sm !leading-none text-surface-500hover:text-surface-900 `)
          }, null, 2), _createElementVNode("span", {
            class: _normalizeClass(["font-medium text-sm leading-tight", {
              'text-primary-500': openMenuKeys.value.has(menuItem.key)
            }])
          }, _toDisplayString(menuItem.label), 3)]),
          _: 2
        }, 1032, ["to"])) : menuItem.items && menuItem.visible ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", {
          onClick: $event => toggleMenu(menuItem.key),
          class: "flex items-center justify-between cursor-pointer p-2 gap-2 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150"
        }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("i", {
          class: _normalizeClass(`${menuItem.icon} !text-sm !leading-none text-surface-500 hover:text-surface-900 w-4`)
        }, null, 2), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", {
          class: _normalizeClass(["font-medium text-sm leading-tight", {
            'text-primary-500': openMenuKeys.value.has(menuItem.key)
          }])
        }, _toDisplayString(menuItem.label), 3), menuItem.comingSoon ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref($tf)("sidebar.dashboard.soon|hamarosan")), 1)) : _createCommentVNode("", true)])]), menuItem.items.length > 0 ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(["fa-regular fa-chevron-right !text-xs !leading-none text-surface-500 ml-auto transition-transform", {
            '-rotate-90': openedMenus.value.includes(menuItem.key)
          }])
        }, null, 2)) : _createCommentVNode("", true)], 8, _hoisted_11), _createElementVNode("ul", {
          class: _normalizeClass([[openedMenus.value.includes(menuItem.key) ? 'max-h-full' : 'max-h-0'], "ml-4 pl-0 translate-x-[-1px] border-l border-surface-200 list-none m-0 overflow-hidden flex flex-col transition-[max-height] duration-500 ease-in-out"])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.items, menuSubItem => {
          return _withDirectives((_openBlock(), _createElementBlock("li", {
            key: menuSubItem.key
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(menuSubItem.link ? 'router-link' : 'div'), {
            to: menuSubItem.link || undefined,
            class: _normalizeClass(["flex items-center p-2 gap-2 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150 hover:text-surface-900", menuSubItem.link ? 'cursor-pointer' : 'cursor-default'])
          }, {
            default: _withCtx(() => [_createElementVNode("i", {
              class: _normalizeClass(`${menuSubItem.icon} !text-sm !leading-none text-surface-500 hover:text-surface-900`)
            }, null, 2), _createElementVNode("span", {
              class: _normalizeClass(["font-medium text-sm leading-tight", {
                'text-primary-500': openMenuKeys.value.has(menuSubItem.key)
              }])
            }, _toDisplayString(menuSubItem.label), 3), menuSubItem.key === 'time.requests' ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(pendingRequestsCount.value), 1)) : menuSubItem.comingSoon ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref($tf)("sidebar.dashboard.soon|hamarosan")), 1)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["to", "class"]))])), [[_vShow, menuSubItem.visible]]);
        }), 128))], 2)], 64)) : _createCommentVNode("", true)], 64);
      }), 128))])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("a", {
        onClick: toggleProfileMenu,
        class: "flex items-center cursor-pointer p-3.5 gap-2 text-surface-900 hover: transition-colors duration-150 border-t border-surface-200"
      }, [_createElementVNode("img", {
        src: avatar.value,
        alt: "Avatar",
        class: "w-8 h-8 rounded-full"
      }, null, 8, _hoisted_18), _createElementVNode("span", _hoisted_19, _toDisplayString(displayName.value), 1), _cache[2] || (_cache[2] = _createElementVNode("i", {
        class: "fa-regular fa-angles-up-down !text-sm !leading-none text-surface-500 ml-auto"
      }, null, -1))]), _createVNode(_unref(Popover), {
        ref_key: "profileMenu",
        ref: profileMenu,
        pt: {
          root: {
            class: 'w-[260px] !ml-2.5',
            style: {
              padding: '0 !important'
            }
          }
        }
      }, {
        default: _withCtx(() => [_createElementVNode("ul", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(LanguageSelector, {
          class: "w-full"
        }), _createVNode(ThemeSelector, {
          class: "w-full"
        })]), _createElementVNode("div", _hoisted_22, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: "/profile#general",
          class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-full",
          onClick: toggleProfileMenu
        }, {
          default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("i", {
            class: "fa-regular fa-user !text-sm !leading-none"
          }, null, -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(_unref($tf)("sidebar.profile|Profil")), 1)]),
          _: 1
        })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: "/settings",
          class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-full",
          onClick: toggleProfileMenu
        }, {
          default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("i", {
            class: "fa-regular fa-gear !text-sm !leading-none"
          }, null, -1)), _createElementVNode("span", _hoisted_24, _toDisplayString(_unref($tf)("sidebar.settings.menu|Beállítások")), 1)]),
          _: 1
        })])]), _createElementVNode("li", _hoisted_25, [_createElementVNode("a", {
          class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-full",
          onClick: _cache[0] || (_cache[0] = $event => logout())
        }, [_cache[5] || (_cache[5] = _createElementVNode("i", {
          class: "fa-regular fa-sign-out !text-sm !leading-none text-red-500 dark:text-red-700"
        }, null, -1)), _createElementVNode("span", _hoisted_26, _toDisplayString(_unref($tf)("sidebar.logout|Kilépés")), 1)])])])]),
        _: 1
      }, 512)])])]);
    };
  }
};